import {
  GETList, 
  GETDetail,
  POSTWithToken,
  DELETEWithToken,
  PUTWithToken,
  GETAutoComplete,
} from "@/services/base-service";

const API_URL = "/api/job-type/v1";

export const getJobType = (values) => {
  const url = `${API_URL}/list`;
  return GETList(url, values);
};

export function createJobType(values) {
  const url = `${API_URL}/create`;
  return POSTWithToken(url, values);
}

export function getJobTypeAutoComplete(query, extra) {
  const url = `${API_URL}/autoComplete`;
  return GETAutoComplete(url, query, extra);
}

export function getJobTypeDetail(id) {
  return GETDetail(API_URL, id);
}

export function editJobType(values) {
  const { id } = values;
  const url = `${API_URL}/${id}`;
  return PUTWithToken(url, values);
}

export function archiveJobType(id) {
  const url = `${API_URL}/${id}/soft`;
  return DELETEWithToken(url);
}

export function unarchiveJobType(id) {
  const url = `${API_URL}/${id}/unarchive`;
  return PUTWithToken(url);
}

export function deleteJobType(id) {
  const url = `${API_URL}/${id}`;
  return DELETEWithToken(url);
}